import Component from '@glimmer/component';

import { service } from '@ember/service';
import LeafletMap from 'ember-leaflet/components/leaflet-map';

import mapConfig from 'rise-ui/helpers/map-config.js';

export default class LocationMapComponent extends Component {
  @service ssr;

  <template>
    {{#unless this.ssr.isSsr}}
      {{#if @location.latLng}}
        <LeafletMap
          @lat={{@location.lat}}
          @lng={{@location.lng}}
          @zoom={{mapConfig "pointZoom"}}
          ...attributes
          as | layers |
        >
          <layers.tile
            @url={{mapConfig "tileUrl"}}
            @attribution={{mapConfig "tileAttrib"}}
          />
          <layers.marker @location={{@location.latLng}} />
        </LeafletMap>
      {{else}}
        <LeafletMap
          @bounds={{@location.bounds}}
          ...attributes
          as | layers |
        >
          <layers.tile
            @url={{mapConfig "tileUrl"}}
            @attribution={{mapConfig "tileAttrib"}}
          />
          <layers.geojson @geoJSON={{@location.coordinates}} />
        </LeafletMap>
      {{/if}}
    {{/unless}}
  </template>
}
